export default {
  newVendorInfo: [],
  carouselImgs: [],
  latestNews: [],
  loginSidebar: [],
};
